export default "__VITE_ASSET__CGTEG8si__"